export enum ELunchPlanType {
  Takeaway = 'TAKEAWAY',
  EatOut = 'EAT_OUT',
}
